(function() {

    'use strict';

    angular.module('app').controller('AccountingCustomerBillingController', AccountingCustomerBillingController);

    AccountingCustomerBillingController.$inject = ['AccountingCustomerBillingTableService'];

    function AccountingCustomerBillingController(AccountingCustomerBillingTableService) {

        const vm = this;
        vm.accountingCustomerBillingTable = new AccountingCustomerBillingTableService({
            filters:  {
                pending: true
            }
        });
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCustomerBillingController.js